export default __webpack_public_path__ + "static/media/Siemens190721.a4b5538d.jpg";